import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import mamaearth from "../assets/mamaearth.png";
import lenskart from "../assets/Lenskart.png";
import boat from "../assets/boat.png";
import amazon from "../assets/amazon.png";
import flipkart from "../assets/flipkart.png";
import myntra from "../assets/myntra.png";
import makemytrip from "../assets/makemytrip.png";
import nike from "../assets/nike.png";

import "./Rewards.css";
import coinIcon from "../assets/coin.png";

import { useCheckSessionHeartBeat } from "components/API/ApiEnpoints";
import { SessionExtend } from "components/utils/SessionCheckUtils";

const rewardsData = {
  coinBalance: 113,

  // -------- VOUCHERS --------
  todaysDeals: [
    {
      id: 1,
      image: mamaearth,
      title: "Mama Earth ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1000,
      details: [
        "Coupon available on Mama Earth site and app",
        "Valid on ₹1000+ purchase",
        "Single use only",
        "Cannot be combined with other offers",
        "Expires in 30 days",
      ],
      website: "https://www.mamaearth.com",
    },
    {
      id: 2,
      image: lenskart,
      title: "Lenskart ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1500,
      details: [
        "Can be used on Lenskart website or app",
        "Valid on ₹1500+ purchase",
        "Not valid on prescription lenses",
        "Single use only",
        "Expires in 60 days",
      ],
      website: "https://www.lenskart.com",
    },
    {
      id: 1,
      image: mamaearth,
      title: "Mama Earth ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1000,
      details: [
        "Coupon available on Mama Earth site and app",
        "Valid on ₹1000+ purchase",
        "Single use only",
        "Cannot be combined with other offers",
        "Expires in 30 days",
      ],
      website: "https://www.mamaearth.com",
    },
    {
      id: 2,
      image: lenskart,
      title: "Lenskart ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1500,
      details: [
        "Can be used on Lenskart website or app",
        "Valid on ₹1500+ purchase",
        "Not valid on prescription lenses",
        "Single use only",
        "Expires in 60 days",
      ],
      website: "https://www.lenskart.com",
    },
    {
      id: 1,
      image: mamaearth,
      title: "Mama Earth ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1000,
      details: [
        "Coupon available on Mama Earth site and app",
        "Valid on ₹1000+ purchase",
        "Single use only",
        "Cannot be combined with other offers",
        "Expires in 30 days",
      ],
      website: "https://www.mamaearth.com",
    },
    {
      id: 2,
      image: lenskart,
      title: "Lenskart ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1500,
      details: [
        "Can be used on Lenskart website or app",
        "Valid on ₹1500+ purchase",
        "Not valid on prescription lenses",
        "Single use only",
        "Expires in 60 days",
      ],
      website: "https://www.lenskart.com",
    },
    {
      id: 1,
      image: mamaearth,
      title: "Mama Earth ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1000,
      details: [
        "Coupon available on Mama Earth site and app",
        "Valid on ₹1000+ purchase",
        "Single use only",
        "Cannot be combined with other offers",
        "Expires in 30 days",
      ],
      website: "https://www.mamaearth.com",
    },
    {
      id: 2,
      image: lenskart,
      title: "Lenskart ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1500,
      details: [
        "Can be used on Lenskart website or app",
        "Valid on ₹1500+ purchase",
        "Not valid on prescription lenses",
        "Single use only",
        "Expires in 60 days",
      ],
      website: "https://www.lenskart.com",
    },
    {
      id: 1,
      image: mamaearth,
      title: "Mama Earth ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1000,
      details: [
        "Coupon available on Mama Earth site and app",
        "Valid on ₹1000+ purchase",
        "Single use only",
        "Cannot be combined with other offers",
        "Expires in 30 days",
      ],
      website: "https://www.mamaearth.com",
    },
    {
      id: 2,
      image: lenskart,
      title: "Lenskart ₹300 off coupon",
      cost: 2500,
      rewardValue: "₹300 off",
      minimumOrder: 1500,
      details: [
        "Can be used on Lenskart website or app",
        "Valid on ₹1500+ purchase",
        "Not valid on prescription lenses",
        "Single use only",
        "Expires in 60 days",
      ],
      website: "https://www.lenskart.com",
    },
  ],

  topDeals: [
    {
      id: 11,
      image: amazon,
      title: "Amazon ₹250 gift card",
      cost: 2500,
      rewardValue: "₹250 gift card",
      details: [
        "Redeemable on Amazon website & app",
        "Valid on all products",
        "Single use per account",
        "Cannot combine with other coupons",
        "Expires in 90 days",
      ],
      website: "https://www.amazon.in",
    },
    {
      id: 12,
      image: flipkart,
      title: "Flipkart ₹150 gift card",
      cost: 2500,
      rewardValue: "₹150 gift card",
      details: [
        "Redeemable on Flipkart site & app",
        "Valid on all categories",
        "Single use only",
        "Cannot combine with other offers",
        "Expires in 90 days",
      ],
      website: "https://www.flipkart.com",
    },
  ],

  // -------- COUPONS --------
  coupons: {
    todaysDeals: [
      {
        id: 21,
        image: myntra,
        title: "Myntra ₹500 off coupon",
        cost: 2000,
        rewardValue: "₹500 off",
        minimumOrder: 1500,
        details: [
          "Valid on Myntra site & app",
          "₹1500 minimum order required",
          "Valid only on fashion category",
          "Single use per account",
          "Expires in 30 days",
        ],
        website: "https://www.myntra.com",
      },
      {
        id: 22,
        image: boat,
        title: "Boat ₹300 off coupon",
        cost: 2200,
        rewardValue: "₹300 off",
        minimumOrder: 1000,
        details: [
          "Applicable on Boat official website",
          "Valid for select products only",
          "₹1000 minimum purchase",
          "Cannot combine with other promo codes",
          "Expires in 45 days",
        ],
        website: "https://www.boat-lifestyle.com",
      },
    ],
    topDeals: [
      {
        id: 23,
        image: makemytrip,
        title: "MakeMyTrip ₹400 off coupon",
        cost: 3000,
        rewardValue: "₹400 off",
        details: [
          "Valid on flights and hotels",
          "Redeemable on MakeMyTrip app",
          "One-time use only",
          "Not combinable with other offers",
          "Valid for 60 days",
        ],
        website: "https://www.makemytrip.com",
      },
      {
        id: 24,
        image: nike,
        title: "Nike ₹600 off coupon",
        cost: 3500,
        rewardValue: "₹600 off",
        details: [
          "Valid on Nike website and app",
          "Applicable for apparel & footwear",
          "Single use only",
          "Cannot combine with sale discounts",
          "Expires in 90 days",
        ],
        website: "https://www.nike.com",
      },
    ],
  },
};

const Rewards = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<"vouchers" | "coupons">(
    "vouchers"
  );
  const [selectedReward, setSelectedReward] = useState<any>(null);

  const rewards =
    activeTab === "vouchers"
      ? { todaysDeals: rewardsData.todaysDeals, topDeals: rewardsData.topDeals }
      : {
          todaysDeals: rewardsData.coupons.todaysDeals,
          topDeals: rewardsData.coupons.topDeals,
        };

  const handleBuyClick = (reward: any) => setSelectedReward(reward);
  const handleCloseModal = () => setSelectedReward(null);

  return (
    <div className="RewardsMessage">This section is under development...</div>
    // <div className="rewards-container">
    //   <div className="coin-balance-section">
    //     <div className="coin-left">
    //       <img src={coinIcon} alt="Coin Icon" className="coin-icon" />
    //       <div className="coin-banner">
    //         <h2>{rewardsData.coinBalance}</h2>
    //         <p>Points Balance</p>
    //       </div>
    //     </div>

    //     <div className="coin-right">
    //       <p>Earned Vouchers : </p>
    //       <p>Earned Coupons : </p>
    //     </div>

    //     <button
    //       className="earned-history-btn"
    //       onClick={() => navigate("/rewards-history")}
    //     >
    //       Earned History
    //     </button>
    //   </div>

    //   <div className="rewards-buttons">
    //     <button
    //       className={activeTab === "vouchers" ? "active" : ""}
    //       onClick={() => setActiveTab("vouchers")}
    //     >
    //       Vouchers
    //     </button>
    //     <div className="divider"></div>
    //     <button
    //       className={activeTab === "coupons" ? "active" : ""}
    //       onClick={() => setActiveTab("coupons")}
    //     >
    //       Coupons
    //     </button>
    //   </div>
    //   <hr className="bottom-line" />

    //   {/* Available Section */}
    //   <section className="deals-section">
    //     <h2 className="deals-title">
    //       {activeTab === "vouchers"
    //         ? "Available Vouchers"
    //         : "Available Coupons"}
    //     </h2>
    //     <div className="deals-container">
    //       {rewards.topDeals.map((deal, index) => (
    //         <div
    //           key={deal.id}
    //           className={`deal-card ${
    //             index % 3 === 0
    //               ? "green-card"
    //               : index % 3 === 1
    //               ? "purple-card"
    //               : "blue-card"
    //           }`}
    //           onClick={() => handleBuyClick(deal)}
    //         >
    //           <img src={deal.image} alt={deal.title} />
    //           <p>{deal.title}</p>
    //           <span>for {deal.cost} points</span>
    //           <button className="buy-btn">Buy</button>
    //         </div>
    //       ))}
    //     </div>
    //   </section>

    //   {/* Earned Section */}
    //   <section className="deals-section" style={{ marginBottom: "30px" }}>
    //     <h2 className="deals-title">
    //       {activeTab === "vouchers" ? "Earned Vouchers" : "Earned Coupons"}
    //     </h2>
    //     <div className="deals-container">
    //       {rewards.todaysDeals.map((deal, index) => (
    //         <div
    //           key={deal.id}
    //           className={`deal-card ${
    //             index % 3 === 0
    //               ? "green-card"
    //               : index % 3 === 1
    //               ? "purple-card"
    //               : "blue-card"
    //           }`}
    //           onClick={() => handleBuyClick(deal)}
    //         >
    //           <img src={deal.image} alt={deal.title} />
    //           <p>{deal.title}</p>
    //           <span>for {deal.cost} points</span>
    //           <button className="buy-btn">Buy</button>
    //         </div>
    //       ))}
    //     </div>
    //   </section>

    //   {/* Modal Section */}
    //   {selectedReward && (
    //     <ModalOverlay onClick={handleCloseModal}>
    //       <ModalContent onClick={(e) => e.stopPropagation()}>
    //         <button
    //           onClick={handleCloseModal}
    //           style={{
    //             position: "absolute",
    //             top: "10px",
    //             right: "12px",
    //             backgroundColor: "transparent",
    //             border: "none",
    //             fontSize: "30px",
    //             fontWeight: "bold",
    //             cursor: "pointer",
    //             color: "#0b0b0aff",
    //           }}
    //         >
    //           ×
    //         </button>

    //         <div
    //           style={{
    //             display: "flex",
    //             gap: "20px",
    //             marginBottom: "20px",
    //             flexWrap: "wrap",
    //           }}
    //         >
    //           <div
    //             style={{
    //               flex: "1",
    //               display: "flex",
    //               justifyContent: "center",
    //               alignItems: "center",
    //             }}
    //           >
    //             <img
    //               src={selectedReward.image}
    //               alt={selectedReward.title}
    //               style={{
    //                 width: "120px",
    //                 height: "120px",
    //                 objectFit: "contain",
    //                 border: "1px solid #ddd",
    //                 borderRadius: "8px",
    //                 padding: "4px",
    //                 backgroundColor: "#fff",
    //               }}
    //             />
    //           </div>

    //           <div
    //             style={{
    //               flex: "2",
    //               minWidth: "200px",
    //               marginTop: "20px",
    //               marginLeft: "15px",
    //               textAlign: "left",
    //             }}
    //           >
    //             <h3 style={{ margin: "0 0 10px 0", fontWeight: "bold" }}>
    //               {selectedReward.title}
    //             </h3>
    //             <p style={{ margin: "5px 0" }}>
    //               <strong>Reward:</strong> {selectedReward.rewardValue}
    //             </p>
    //             <p style={{ margin: "5px 0" }}>
    //               <strong>Cost:</strong> {selectedReward.cost} points
    //             </p>
    //           </div>
    //         </div>

    //         <div style={{ marginTop: "20px" }}>
    //           <div
    //             style={{
    //               display: "flex",
    //               alignItems: "center",
    //               marginBottom: "10px",
    //             }}
    //           >
    //             <hr
    //               style={{
    //                 flex: 1,
    //                 border: "none",
    //                 borderTop: "1px solid #ccc",
    //               }}
    //             />
    //             <h4 style={{ margin: "0 10px", fontWeight: "bold" }}>
    //               Offer Details
    //             </h4>
    //             <hr
    //               style={{
    //                 flex: 1,
    //                 border: "none",
    //                 borderTop: "1px solid #ccc",
    //               }}
    //             />
    //           </div>
    //           <ul
    //             style={{
    //               paddingLeft: "20px",
    //               marginTop: "10px",
    //               textAlign: "left",
    //               fontSize: "14px",
    //             }}
    //           >
    //             {selectedReward.details.map((point: string, idx: number) => (
    //               <li key={idx} style={{ marginBottom: "5px" }}>
    //                 {point}
    //               </li>
    //             ))}
    //           </ul>
    //         </div>

    //         <p style={{ marginTop: "10px", textAlign: "center" }}>
    //           <strong>Visit:</strong>{" "}
    //           <a
    //             href={selectedReward.website}
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             style={{ color: "blue", textDecoration: "underline" }}
    //           >
    //             {selectedReward.website}
    //           </a>
    //         </p>

    //         <div
    //           style={{
    //             marginTop: "20px",
    //             display: "flex",
    //             justifyContent: "center",
    //           }}
    //         >
    //           <button
    //             style={{
    //               padding: "10px 20px",
    //               backgroundColor: "#4CAF50",
    //               color: "white",
    //               border: "none",
    //               borderRadius: "5px",
    //               cursor: "pointer",
    //               width: "20%",
    //             }}
    //             onClick={() => {
    //               alert(`You have claimed ${selectedReward.title}!`);
    //               handleCloseModal();
    //             }}
    //           >
    //             Claim
    //           </button>
    //         </div>
    //       </ModalContent>
    //     </ModalOverlay>
    //   )}
    // </div>
  );
};

export default Rewards;
export { rewardsData };

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  position: relative; /* Added to make cancel button visible */
  background: white;
  width: 80%;
  max-width: 28%;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  max-height: 80vh;
  overflow-y: auto;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
